<template>
  <v-container class="proof-settings" fluid>
    <page-title title="Settings"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <v-layout v-if="loading" fill-height align-center justify-center>
      <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
    </v-layout>
    <v-layout v-if="!loading" align-center class="setting">
      <span>Show each proof card for </span>
      <input
        class="lgrm-box-input"
        type="number"
        @input="save()"
        v-model="formData.msgDelay"
        v-validate="'required|min_value:1|max_value:10'"
        data-vv-as="msgDelay"
        name="msgDelay"
        :class="{ error: errors.collect('msgDelay').length > 0 }"
      />
      <span>seconds</span>
    </v-layout>

    <v-layout v-if="!loading" align-center class="setting">
      <span>Keep  </span>
      <input
        class="lgrm-box-input"
        type="number"
        @input="save()"
        v-model="formData.delayBetweenCards"
        v-validate="'required|min_value:1|max_value:10'"
        data-vv-as="delayBetweenCards"
        name="delayBetweenCards"
        :class="{ error: errors.collect('delayBetweenCards').length > 0 }"
      />
      <span>seconds delay between proof cards</span>
    </v-layout>

    <v-layout v-if="!loading" align-center class="setting">
      <span>If user closes, show the proof widget again in</span>
      <input
        class="lgrm-box-input"
        type="number"
        @input="save()"
        v-model="formData.closeDelay"
        v-validate="'required|min_value:0|max_value:30'"
        data-vv-as="closeDelay"
        name="closeDelay"
        :class="{ error: errors.collect('closeDelay').length > 0 }"
      />
      <span>days</span>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from 'lodash/debounce'
import proofApi from '@/api/proof'
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
import formMixins from '@/mixins/forms'
export default {
  name: 'ProofSettings',
  mixins: [formMixins],
  components: {Tabs},
  mounted() {
    const vm = this
    proofApi
      .getSettings(this.$router.currentRoute.params.campaignId)
      .then(function(res) {
        vm.formData.msgDelay = res.data.results.options.msg_delay
        vm.formData.closeDelay = res.data.results.options.close_delay
        vm.formData.delayBetweenCards = res.data.results.options.delay_between_cards || 3
        vm.loading = false
      })
      .catch(function(res) {
        vm.loading = false
      })
  },
  data: function() {
    return {
      formData: {
        msgDelay: 0,
        closeDelay: 5,
        delayBetweenCards: 3
      },
      settings: null,
      loading: true
    }
  },
  computed: {
    tabSettings: function() {
      return {
        preselected: null,
        tabs: [
          {
            id: routes.PROOF_SETTINGS,
            label: 'Settings'
          },
          {
            id: routes.PROOF_INTEGRATIONS,
            label: 'Integrations'
          },
          {
            id: routes.PROOF_PUBLISH,
            label: 'Publish'
          }
        ]
      }
    }
  },
  methods: {
    save: debounce(function() {
      if (!this.isFormValid) {
        return
      }
      const data = {
        close_delay: +this.formData.closeDelay,
        msg_delay: +this.formData.msgDelay,
        delay_between_cards: +this.formData.delayBetweenCards
      }
      proofApi
        .saveSettings(this.$router.currentRoute.params.campaignId, {
          options: data
        })
        .then(function(campaign) {
          console.log(campaign)
        })
    }, 500)
  }
}
</script>

<style lang="stylus">
.proof-settings {
    .setting {
        margin-bottom 37px
        font-size 16px
    }
    .lgrm-box-input {
        width 60px
        margin 0 5px
    }
}
</style>
